import React from 'react';
import { motion } from 'framer-motion';

const Logo = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  return (
    <motion.div 
      className={`${sizeClasses[size]} ${className} relative`}
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.2 }}
    >
      <svg
        viewBox="0 0 100 100"
        className="w-full h-full"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer circle with gradient */}
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="url(#gradient1)"
          stroke="url(#gradient2)"
          strokeWidth="3"
        />
        
        {/* Ghost body - rounded rectangle */}
        <path
          d="M25 35 C25 25, 35 15, 50 15 C65 15, 75 25, 75 35 L75 70 L70 65 L65 70 L60 65 L55 70 L50 65 L45 70 L40 65 L35 70 L30 65 L25 70 Z"
          fill="white"
          opacity="0.95"
        />
        
        {/* Ghost eyes */}
        <circle cx="42" cy="35" r="3" fill="url(#gradient4)" />
        <circle cx="58" cy="35" r="3" fill="url(#gradient4)" />
        
        {/* Food elements - burger layers */}
        <rect x="38" y="45" width="24" height="3" rx="1.5" fill="#F59E0B" />
        <rect x="40" y="50" width="20" height="2" rx="1" fill="#10B981" />
        <rect x="38" y="54" width="24" height="4" rx="2" fill="#8B4513" />
        
        {/* Kitchen steam lines */}
        <path d="M35 25 Q35 20, 37 25" stroke="url(#gradient3)" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
        <path d="M45 22 Q45 17, 47 22" stroke="url(#gradient3)" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
        <path d="M55 22 Q55 17, 57 22" stroke="url(#gradient3)" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
        <path d="M65 25 Q65 20, 67 25" stroke="url(#gradient3)" strokeWidth="2" strokeLinecap="round" opacity="0.7" />
        
        {/* "FOOD" text integrated */}
        <text x="50" y="68" textAnchor="middle" className="text-xs font-bold fill-purple-600" fontSize="8">
          FOOD
        </text>
        
        {/* Gradients */}
        <defs>
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#8B5CF6" />
            <stop offset="100%" stopColor="#EC4899" />
          </linearGradient>
          <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#A855F7" />
            <stop offset="100%" stopColor="#F472B6" />
          </linearGradient>
          <linearGradient id="gradient3" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#8B5CF6" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#EC4899" stopOpacity="0.4" />
          </linearGradient>
          <linearGradient id="gradient4" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#6366F1" />
            <stop offset="100%" stopColor="#8B5CF6" />
          </linearGradient>
        </defs>
      </svg>
    </motion.div>
  );
};

export default Logo;